import { cloneDeep, get, startsWith, omit } from "lodash";
import qs from "query-string";
import * as atgApi from "@lululemon/ecom-common/src/services/atg";
import Util from "@lululemon/ecom-common/src/lib/util";
import fetchSearchResults from "@lululemon/ecom-cdp/src/graphql/fetchSearchResults";

export function getSearchWidgetMappers() {
  return [
    {
      key: "products",
      label: "Products",
      count: 0,
      index: 0,
      navigationUrl: "",
      tileData: null,
      currentPagingParameters: {
        page: 1,
        pageSize: 20,
      },
      sortOptions: [
        {
          label: "Relevance",
          navigationUrl: "",
        },
      ],
      currentSortIndex: 0,
    },
    {
      key: "ambassadors",
      label: "Ambassadors",
      count: 0,
      index: 1,
      navigationUrl: "",
      tileData: null,
      currentPagingParameters: {
        page: 1,
        pageSize: 20,
      },
      isLazyLoadRequired: false,
      sortOptions: [
        {
          label: "Relevance",
          navigationUrl: "",
        },
      ],
      currentSortIndex: 0,
    },
    {
      key: "features",
      label: "Features",
      count: 0,
      index: 2,
      navigationUrl: "",
      tileData: null,
      currentPagingParameters: {
        page: 1,
        pageSize: 20,
      },
      isLazyLoadRequired: false,
      sortOptions: [
        {
          label: "Relevance",
          navigationUrl: "",
        },
      ],
      currentSortIndex: 0,
    },
    {
      key: "designs",
      label: "Designs",
      count: 0,
      index: 3,
      navigationUrl: "",
      tileData: null,
      currentPagingParameters: {
        page: 1,
        pageSize: 20,
      },
      isLazyLoadRequired: false,
      sortOptions: [
        {
          label: "Relevance",
          navigationUrl: "",
        },
      ],
      currentSortIndex: 0,
    },
    {
      key: "community",
      label: "Community",
      count: 0,
      index: 4,
      tileData: null,
      currentPagingParameters: {
        page: 1,
        pageSize: 20,
      },
      isLazyLoadRequired: false,
      sortOptions: [
        {
          label: "Relevance",
          navigationUrl: "",
        },
      ],
      currentSortIndex: 0,
    },
    {
      key: "stores",
      label: "Stores",
      count: 0,
      index: 5,
      navigationUrl: "",
      tileData: null,
      currentPagingParameters: {
        page: 1,
        pageSize: 20,
      },
      isLazyLoadRequired: false,
      sortOptions: [
        {
          label: "Relevance",
          navigationUrl: "",
        },
      ],
      currentSortIndex: 0,
    },
  ];
}

function getAutoSuggestUrl() {
  return atgApi.getAutoSuggestUrl();
}

export function checkForLazyLoad(currentTileCategory) {
  try {
    let isLazyLoad = true;
    const {
      currentPagingParameters: { page, pageSize },
      count,
    } = currentTileCategory;
    if (count <= page * pageSize) {
      isLazyLoad = false;
    }
    return isLazyLoad;
  } catch (ex) {
    console.error(ex);
    return false;
  }
}

export function getMainContent(mainContent) {
  if (
    mainContent[0].type === "AmbassadorsSearchResultsList" ||
    mainContent[0].type === "DesignsSearchResultsList" ||
    mainContent[0].type === "CommunitySearchResultsList" ||
    mainContent[0].type === "FeaturesSearchResultsList" ||
    mainContent[0].type === "ProductsResultsList" ||
    mainContent[0].type === "StoresSearchResultsList"
  ) {
    mainContent = mainContent[0];
  } else if (
    (mainContent[1] &&
      mainContent[1].type === "AmbassadorsSearchResultsList") ||
    (mainContent[1] && mainContent[1].type === "DesignsSearchResultsList") ||
    (mainContent[1] && mainContent[1].type === "CommunitySearchResultsList") ||
    (mainContent[1] && mainContent[1].type === "FeaturesSearchResultsList") ||
    (mainContent[1] && mainContent[1].type === "ProductsResultsList") ||
    (mainContent[1] && mainContent[1].type === "StoresSearchResultsList")
  ) {
    mainContent = mainContent[1];
  } else if (
    (mainContent[2] &&
      mainContent[2].type === "AmbassadorsSearchResultsList") ||
    (mainContent[2] && mainContent[2].type === "DesignsSearchResultsList") ||
    (mainContent[2] && mainContent[2].type === "CommunitySearchResultsList") ||
    (mainContent[2] && mainContent[2].type === "FeaturesSearchResultsList") ||
    (mainContent[2] && mainContent[2].type === "ProductsResultsList") ||
    (mainContent[2] && mainContent[2].type === "StoresSearchResultsList")
  ) {
    mainContent = mainContent[2];
  }

  return mainContent;
}

export function getUpdatedResultsArray(lazyLoadedData, currentTileCategory) {
  const updatedResults = cloneDeep(currentTileCategory.tileData);

  if (currentTileCategory.key === "products") {
    const newResults =
      lazyLoadedData.data.attributes["main-content"][0].records;
    const existingRecords =
      currentTileCategory.tileData.attributes["main-content"][0].records;
    updatedResults.attributes["main-content"][0].records = [
      ...existingRecords,
      ...newResults,
    ];
  } else {
    // TODO when non product categories return results
    const newResults =
      lazyLoadedData.data.attributes["main-content"][0].records;
    const existingRecords =
      currentTileCategory.tileData.attributes["main-content"][0].records;
    updatedResults.attributes["main-content"][0].records = [
      ...existingRecords,
      ...newResults,
    ];
  }
  return updatedResults;
}

export function getUpdatedCategories(data, mainContent, currentNavigationUrl) {
  if (!data) {
    const categories = getSearchWidgetMappers();
    return {
      updatedCategories: categories,
      highestCategoryIndex: 0,
      highestCount: 0,
    };
  }

  let currentCategoryIndex = 0;
  let highestCount = 0;
  switch (mainContent.type) {
    case "ProductsResultsList":
      currentCategoryIndex = 0;
      break;

    case "AmbassadorsSearchResultsList":
      currentCategoryIndex = 1;
      break;

    case "FeaturesSearchResultsList":
      currentCategoryIndex = 2;
      break;

    case "DesignsSearchResultsList":
      currentCategoryIndex = 3;
      break;

    case "CommunitySearchResultsList":
      currentCategoryIndex = 4;
      break;

    case "StoresSearchResultsList":
      currentCategoryIndex = 5;
      break;
    default:
      currentCategoryIndex = 0;
  }

  const updatedCategoryCounts = getSearchWidgetMappers();
  const matchedData = get(
    data,
    "attributes[secondary-content][2].navigation[0].refinements",
    null
  );
  if (matchedData) {
    matchedData.forEach((category) => {
      const keyName = category.label;
      const matchedCategory = updatedCategoryCounts.find(
        (ele) => ele.key === keyName
      );
      if (matchedCategory) {
        matchedCategory.count = category.count;
        matchedCategory.navigationUrl = category["navigation-state"];
      }
    });
  }

  const category = updatedCategoryCounts[currentCategoryIndex];
  category.navigationUrl = currentNavigationUrl;
  category.tileData = data;
  category.isLazyLoadRequired = checkForLazyLoad(category);
  category.sortOptions = getSortOptions(category);
  highestCount = category.count;

  return {
    updatedCategories: updatedCategoryCounts,
    highestCategoryIndex: currentCategoryIndex,
    highestCount,
  };
}

export function getSortOptions(category) {
  const sortOptionsArr = [];
  const isFusionSort =
    category.tileData.attributes["main-content"][0]["fusion-query-id"];
  if (!isFusionSort) {
    // endeca
    const defaultSortOption = Object.assign({}, category.sortOptions[0]);
    defaultSortOption.navigationUrl = category.navigationUrl;
    sortOptionsArr.push(defaultSortOption);
  }
  try {
    category.tileData.attributes["main-content"][0]["sort-options"].forEach(
      (sortOption) => {
        const sortOptionObj = {};
        sortOptionObj.label = sortOption.label;
        sortOptionObj.navigationUrl = sortOption["navigation-state"];
        sortOptionsArr.push(sortOptionObj);
      }
    );
    return sortOptionsArr;
  } catch (ex) {
    return sortOptionsArr;
  }
}

function getFormattedText(text, searchTerm) {
  let newlyFormattedText = "";
  const textArr = [];
  if (searchTerm.length > 2 && searchTerm.split(" ").length === 1) {
    const splitText = text.split(" ");
    splitText.forEach((word) => {
      if (startsWith(word.toLowerCase(), searchTerm.toLowerCase())) {
        textArr.push(`<mark>${word}</mark>`);
      } else {
        textArr.push(word);
      }
    });
  } else {
    newlyFormattedText += `<span>${text}`;
  }

  newlyFormattedText += `<span>${textArr.join("&nbsp;")}</span>`;
  return newlyFormattedText;
}

export function formatSearchResults(searchTerm, searchResults) {
  const formattedSuggestions = [];
  const formattedProducts = [];
  const unformattedResults = [];
  if (searchResults.suggestions.length > 0) {
    searchResults.suggestions.map((result) => {
      const title = getFormattedText(result.value, searchTerm);
      const { url } = result.data;
      const formattedResult = { title, url };
      formattedSuggestions.push(formattedResult);
      unformattedResults.push(result.value);
    });
  }

  if (
    searchResults.search_summary[0] &&
    searchResults.search_summary[0].products.count
  ) {
    const resultObj = searchResults.search_summary[0].products.items;
    resultObj.map((result) => {
      const title = getFormattedText(result.title, searchTerm);
      const { url } = result;
      const formattedResult = { title, url };
      formattedProducts.push(formattedResult);
      unformattedResults.push(result.title);
    });
  }
  return {
    unformattedResults,
    formattedProducts,
    formattedSuggestions,
  };
}

export function getAutoCompleteResults(util, searchTerm) {
  return util.api({
    url: atgApi.getAutoCompleteUrl(searchTerm),
    redirect: false,
  });
}

export function getSearchUrl(searchTerm, currentPagingParam, useLWApi) {
  return atgApi.getSearchUrl(searchTerm, currentPagingParam, useLWApi);
}

export function getSearchResults(searchTerm, util, useLWApi) {
  const currentPagingParam = {
    page: 1,
    pageSize: 20,
  };
  return util.api({
    // eslint-disable-next-line import/no-named-as-default-member
    url: atgApi.getSearchUrl(
      Util.sanitize(searchTerm),
      currentPagingParam,
      useLWApi
    ),
    redirect: false,
  });
}

export function getCleanedSearchUrl(navigationUrl) {
  const parsed = qs.parse(navigationUrl.split("?")[1] || "");
  const cleaned = qs.stringify(
    omit(parsed, [
      "locale",
      "page[offset]",
      "page[limit]",
      "session",
      "userId",
      "fusionExperimentVariant",
    ])
  );
  return `/search?${cleaned}`;
}

export function checkForRedirects(apiResponse, useLWAPI) {
  const isRedirect = {
    redirect: false,
    url: "",
  };
  const redirectVal = useLWAPI ? "redirect" : "endeca:redirect";
  try {
    if (apiResponse[redirectVal]) {
      const { url } = apiResponse[redirectVal].link;
      // const pat = /^https?:\/\//i;
      isRedirect.redirect = true;
      isRedirect.url = url;
    }
    return isRedirect;
  } catch (ex) {
    return isRedirect;
  }
}

export function getSearchResultsAfterInitLoad(
  category,
  graphQueryParams,
  graphqlClient
) {
  // Kiwi Server SNB
  return fetchSearchResults(
    graphqlClient,
    category.navigationUrl,
    category.currentPagingParameters,
    graphQueryParams
  );
}
